"use strict"
exports.__esModule = true;
exports.ShekelSignIconConfig = {
  name: 'ShekelSignIcon',
  height: 512,
  width: 448,
  svgPath: 'M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z',
  yOffset: 0,
  xOffset: 0,
};
exports.ShekelSignIcon = require('../createIcon').createIcon(exports.ShekelSignIconConfig);
exports["default"] = exports.ShekelSignIcon;